export default {
  header: "Weather Forecast",
  view: "weather",
  weather: {},
  username: {},
  date: new Date()
};
